export const observable = (() => (typeof Symbol === 'function' && Symbol.observable) || '@@observable')();
//# sourceMappingURL=observable.js.map